"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {
    AppWrapper_MainContent: {
      flex: props.AppMaxWidth ? "0 1 ".concat(props.AppMaxWidth) : "1 0 100%",
      display: "flex",
      background: props.AppMainContentBackgroundColor,
      position: "relative"
    },
    AppWrapper_FakeFlex: {
      flex: "1 1 auto",
      background: props.AppSidesBackgroundColor
    }
  };
};

var Lockedstyles = {
  AppWrapper: {
    display: "flex",
    width: "100%",
    height: "100%"
  }
};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    AppWrapper: {},
    AppWrapper_MainContent: theme.AppWrapper_MainContent,
    AppWrapper_FakeFlex: theme.AppWrapper_FakeFlex
  };
});
/**
 * Create a wrapper over the entire APP to handle SideBars and Top/Bottom Nav Bars.
 * The wrapper is a flex Div Element and it creates 3 horizontal divs : Fake - AppContent - Fake so that All Elements are centered and resize dynamically
 */

var AppWrapper = /*#__PURE__*/_react["default"].forwardRef(function AppWrapper(props, ref) {
  var AppMaxWidth = props.AppMaxWidth,
      AppMainContentBackgroundColor = props.AppMainContentBackgroundColor,
      AppSidesBackgroundColor = props.AppSidesBackgroundColor,
      ClassExtendAppFlexMainContent = props.ClassExtendAppFlexMainContent,
      ClassExtendAppFlexFakeSides = props.ClassExtendAppFlexFakeSides,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["AppMaxWidth", "AppMainContentBackgroundColor", "AppSidesBackgroundColor", "ClassExtendAppFlexMainContent", "ClassExtendAppFlexFakeSides", "children"]);
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, other, {
    style: Lockedstyles.AppWrapper,
    className: classes.AppWrapper
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: LockedstylesWithProps(props).AppWrapper_FakeFlex,
    className: (0, _clsx["default"])(classes.AppWrapper_FakeFlex, ClassExtendAppFlexFakeSides)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: LockedstylesWithProps(props).AppWrapper_MainContent,
    className: (0, _clsx["default"])(classes.AppWrapper_MainContent, ClassExtendAppFlexMainContent)
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    style: LockedstylesWithProps(props).AppWrapper_FakeFlex,
    className: (0, _clsx["default"])(classes.AppWrapper_FakeFlex, ClassExtendAppFlexFakeSides)
  }));
});

AppWrapper.defaultProps = {
  AppMaxWidth: null,
  AppMainContentBackgroundColor: null,
  AppSidesBackgroundColor: null,
  ClassExtendAppFlexMainContent: null,
  ClassExtendAppFlexFakeSides: null
};
process.env.NODE_ENV !== "production" ? AppWrapper.propTypes = {
  /**
   * The MaxWidth of the App (pixels by default but you can specify any units)
   */
  AppMaxWidth: _propTypes["default"].string,

  /**
   * background of the Main Content
   */
  AppMainContentBackgroundColor: _propTypes["default"].string,

  /**
   * background of the Sides
   */
  AppSidesBackgroundColor: _propTypes["default"].string,

  /**
   * Class Extends
   */
  ClassExtendAppFlexMainContent: _propTypes["default"].string,

  /**
   * Class Extends
   */
  ClassExtendAppFlexFakeSides: _propTypes["default"].string
} : void 0;
var _default = AppWrapper;
exports["default"] = _default;